import React, { useRef, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { PDFDocument } from "pdf-lib";
import SignaturePad from "react-signature-canvas";

function TestPdf() {
  const [showPdf, setShowPdf] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const sigPadRef = useRef();

  // Your base PDF (put in public folder or load from API)
  const samplePdfUrl = "/file.pdf";

  const handleShow = () => {
    setPdfUrl(samplePdfUrl);
    setShowPdf(true);
  };

  const handleClose = () => {
    setShowPdf(false);
    setPdfUrl(null);
  };

  const handleClear = () => {
    sigPadRef.current.clear();
  };

  // 👉 Preview PDF with signature stamped in last page
  const handleSignPreview = async () => {
    if (sigPadRef.current.isEmpty()) {
      alert("Please add a signature first.");
      return;
    }

    const signatureDataUrl = sigPadRef.current
      .getCanvas()
      .toDataURL("image/png");
    const signatureBytes = await fetch(signatureDataUrl).then((res) =>
      res.arrayBuffer()
    );

    const existingPdfBytes = await fetch(samplePdfUrl).then((res) =>
      res.arrayBuffer()
    );
    const pdfDoc = await PDFDocument.load(existingPdfBytes);

    const sigImage = await pdfDoc.embedPng(signatureBytes);
    const pages = pdfDoc.getPages();
    const lastPage = pages[pages.length - 1];
    const { width } = lastPage.getSize();

    lastPage.drawImage(sigImage, {
      x: width - 200,
      y: 75,
      width: 125,
      height: 60,
    });

    const pdfBytes = await pdfDoc.save();
    const blob = new Blob([pdfBytes], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);

    // 👉 Update preview with signed version
    setPdfUrl(url);
  };

  // 👉 Download the already signed PDF
  const handleDownload = () => {
    if (!pdfUrl) return;
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = "signed.pdf";
    link.click();
  };

  return (
    <div className="p-3">
      <h3>PDF Signing Demo</h3>
      <Button variant="primary" onClick={handleShow}>
        Open Fullscreen PDF
      </Button>

      <Modal
        show={showPdf}
        onHide={handleClose}
        size="lg"
        centered
        dialogClassName="fullscreen-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Preview & Sign PDF</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* PDF Preview */}
          {pdfUrl && (
            <iframe
              src={pdfUrl}
              title="pdf-preview"
              style={{ width: "100%", height: "80vh" }}
            ></iframe>
          )}

          <h5 className="mt-3">Draw Signature:</h5>
          <SignaturePad
            ref={sigPadRef}
            penColor="black"
            canvasProps={{
              width: 600,
              height: 150,
              style: { border: "1px solid #ccc", display: "block" },
            }}
          />
          <Button
            variant="secondary"
            size="sm"
            onClick={handleClear}
            className="mt-2"
          >
            Clear
          </Button>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="warning" onClick={handleSignPreview}>
            Preview Signature
          </Button>
          <Button variant="success" onClick={handleDownload}>
            Download Signed PDF
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default TestPdf;
